import styled from 'styled-components';

export const ProductUploadWrapper = styled.section`
  padding: 30px 34px;
`;
